import React from 'react';
import { Group } from '@landr/maestro';
import { searchV3FilterType } from 'components/Filters/Filters';
import AdvancedFiltersToggle from '../AdvancedFiltersToggle/AdvancedFiltersToggle';
import SearchToolsPopover from './SearchToolsPopover';
import SearchToolsMobile from './SearchToolsMobile';

const SearchTools = ({
    isMobile,
    withAdvancedFilters,
}: {
    isMobile: boolean;
    withAdvancedFilters: boolean;
}) => {
    return (
        <>
            {isMobile ? (
                <SearchToolsMobile />
            ) : (
                <Group
                    gap="xs"
                    justifyContent={isMobile ? 'center' : 'flex-start'}
                    width="100%"
                >
                    <Group.Item display="flex" gap="xs">
                        <SearchToolsPopover
                            toolsType={searchV3FilterType.Types}
                        />
                        <SearchToolsPopover
                            toolsType={searchV3FilterType.BPM}
                        />
                        <SearchToolsPopover
                            toolsType={searchV3FilterType.Key}
                        />
                    </Group.Item>
                    {withAdvancedFilters && (
                        <Group.Item
                            flexGrow={0}
                            textAlign={isMobile ? 'inherit' : 'right'}
                            gap={'xs'}
                            data-testid="advanced-filters-toggle"
                        >
                            <AdvancedFiltersToggle />
                        </Group.Item>
                    )}
                </Group>
            )}
        </>
    );
};

export default SearchTools;
